import React, { Component } from 'react';
import {
  Button,
  Row,
  Col,
  Container, Card, CardHeader, CardBody
} from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.css';
import PermissionWrapper from '../../auth/PermissionWrapper.js';
import SearchForm from '../../components/SearchForm/SearchForm';
import BusinessDemographicsGraph from '../../components/GraphResults/BusinessDemographicsGraph.js';


class BusinessDemographics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_results: false,
      loading: false,
      current_state: 0
    };

    this.state.group_selections = { 'name': "", 'city': "", 'state': "", 'zip': "", 'website': "", 'sec_number': "" };
  }

  handleSubmit = () => {
    this.refs.businessDemographicsGraph.renderData();
    this.setState((prevState) => {

      let search_params = {};
      return {
        search_params: search_params,
        show_results: true,
        loading: true
      };
    });
  }

  onDismissResults = () => {
    this.setState({
      search_params: null,
      show_results: false
    });
  }

  handleStateInputChange = (e) => {
    e.persist();
    this.setState(prevState => {
      const sel = prevState.group_selections;
      var new_current = this.props.us_states.findIndex(d => e.target.value === d.abbr);
      new_current = Math.min(Math.max(new_current, 0), this.props.us_states.length - 1);
      sel[e.target.name] = e.target.value;

      var new_state = {
        current_state: new_current,
        group_selections: sel
      }

      return new_state;

    });

  }

  handleTextInputChange = (e) => {
    e.persist();

    this.setState(prevState => {
      const sel = prevState.group_selections;
      sel[e.target.name] = e.target.value;
      return { group_selections: sel }
    });
  }

  handleKeyUp = (e) => {
    e.persist();
    if (e.key === 'Enter') this.handleSubmit();
  }

  render() {


    return (

      <Container fluid className='p-0'>
        <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
          <Row>
            <Col md={12} className='text-center'>
              <h1>Business Demographics Search</h1>
            </Col>
          </Row>
        </PermissionWrapper>
        <Container fluid>
          <Row key="date_row" >
            <Col>
              <Card className="text-left m-0">
                <CardHeader><h3>Search Criteria</h3></CardHeader>
                <CardBody>
                  <SearchForm
                    clientToken={this.props.clientToken}
                    handleTextInputChange={this.handleTextInputChange}
                    handleStateInputChange={this.handleStateInputChange}
                    handleKeyUp={this.handleKeyUp}
                    usStates={this.props.us_states}
                    currentState={this.state.current_state}
                    groupSelections={this.state.group_selections}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className='my-3'>
            <Col>
              <Button
                key="button1"
                color="primary"
                onClick={this.handleSubmit}
              >Run Report</Button>
            </Col>
          </Row>

          <BusinessDemographicsGraph clientToken={this.props.clientToken} ref="businessDemographicsGraph" groupSelections={this.state.group_selections} />
        </Container>
      </Container>
    )
  }
}

export default BusinessDemographics;
